<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToPic'
});
</script>
<template>
	<span :flex="flex ? flex : null" class="to-pic" :class="setClass" :style="setStyle">
		<img :src="src" class="to-pic-content" :alt="alt" @click="clickHandler" />
		<template v-if="preview">
			<pic-viewer v-if="showViewer" :mask-closable="true" :z-index="zIndex" :initial-index="imageIndex" :on-close="closeViewer" :url-list="previews"></pic-viewer>
		</template>
	</span>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue'
import { picProps } from './pic'
import PicViewer from './PicViewer.vue'



const props = defineProps(picProps)

const showViewer = ref(false)
let prevOverflow = ''

const preview = computed(() => {
	return Array.isArray(props.previews) && props.previews.length > 0
})

const imageIndex = computed(() => {
	let previewIndex = 0
	const srcIndex = (props.previews as string[]).indexOf(props.src)
	if (srcIndex >= 0) {
		previewIndex = srcIndex
	}
	return previewIndex
})

const setClass = computed(() => {
	const arr: string[] = []

	if (props.color) {
		arr.push(`color-${props.color}`)
	}

	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}

	if (props.link) {
		arr.push(`is-link`)
	}

	return arr
})

const setStyle = computed(() => {
	const obj: Record<string, string> = {}

	if (props.width) {
		if (!isNaN(Number(props.width))) {
			obj['--width'] = props.width + 'em'
		} else if (props.width === 'full') {
			obj['--width'] = '100%'
		} else {
			obj['--width'] = String(props.width)
		}
	}

	if (props.height) {
		if (!isNaN(Number(props.height))) {
			obj.height = props.height + 'em'
		} else if (props.height === 'full') {
			obj.height = '100%'
		} else {
			obj.height = String(props.height)
		}
	}

	if (props.height !== 'auto') {
		if (typeof props.height === 'number') {
			obj.height = `${props.height}em`
		} else {
			obj.height = String(props.height)
		}
	}

	if (props.previews && props.previews.length > 0) {
		obj.cursor = 'pointer'
	}

	return obj
})

const clickHandler = () => {
	if (!preview.value) {
		return
	}
	showViewer.value = true
}

const closeViewer = () => {
	document.body.style.overflow = prevOverflow
	showViewer.value = false
}
</script>
